// Review Bills shift-click: the ids of the toggleable rows between the last clicked row (anchor) and
// the shift-clicked row (target), both included, in page order. Only the current page -- what is on
// screen. Rows that cannot be toggled (withheld, red-flagged: excludable false) and rows with a
// request already in flight are skipped. [] when the anchor is not on this page.
export function shiftRangeIds(bills, anchorId, targetId, pendingIds = []) {
    const ids = (bills || []).map((bill) => bill.id)
    const from = ids.indexOf(anchorId)
    const to = ids.indexOf(targetId)
    if (from < 0 || to < 0) return []

    const [start, end] = from <= to ? [from, to] : [to, from]
    return bills
        .slice(start, end + 1)
        .filter((bill) => bill.excludable && !pendingIds.includes(bill.id))
        .map((bill) => bill.id)
}
